export default function Payment() {
  return (
    <section id="payments" className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <span className="text-teal-600 font-semibold text-sm uppercase tracking-wide">Secure Payment</span>
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-12">
          Pay Your Way
        </h2>

        <div className="flex flex-wrap justify-center items-center gap-8 mb-12">
          <div className="grayscale hover:grayscale-0 transition-all cursor-pointer">
            <i className="ri-visa-line text-6xl text-blue-600"></i>
          </div>
          <div className="grayscale hover:grayscale-0 transition-all cursor-pointer">
            <i className="ri-mastercard-line text-6xl text-red-600"></i>
          </div>
          <div className="grayscale hover:grayscale-0 transition-all cursor-pointer">
            <i className="ri-paypal-line text-6xl text-blue-500"></i>
          </div>
          <div className="grayscale hover:grayscale-0 transition-all cursor-pointer">
            <i className="ri-apple-line text-6xl text-gray-900"></i>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <div className="bg-gray-50 rounded-2xl p-6 hover:shadow-lg transition-all">
            <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-lock-line text-3xl text-white"></i>
            </div>
            <h3 className="font-bold text-gray-900 mb-2">SSL Encrypted</h3>
            <p className="text-gray-600 text-sm">Your payment information is fully secure</p>
          </div>

          <div className="bg-gray-50 rounded-2xl p-6 hover:shadow-lg transition-all">
            <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <h3 className="font-bold text-gray-900 mb-2">Money-back Guarantee</h3>
            <p className="text-gray-600 text-sm">100% satisfaction or your money back</p>
          </div>

          <div className="bg-gray-50 rounded-2xl p-6 hover:shadow-lg transition-all">
            <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-check-double-line text-3xl text-white"></i>
            </div>
            <h3 className="font-bold text-gray-900 mb-2">Instant Confirmation</h3>
            <p className="text-gray-600 text-sm">Get immediate booking confirmation</p>
          </div>
        </div>
      </div>
    </section>
  );
}
